import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Pagination from "@mui/material/Pagination";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import InfoBox from "../../components/dashboard/infoboxes/InfoBox";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import TransactionData from "../../components/datatables/transaction/TransactionData";
import { fetchTransactions } from "../../feature/transaction/transactionSlice";

const Transaction = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTransactions());
    window.scrollTo({ top: "0", behavior: "smooth" });
  }, [dispatch]);

  return (
    <>
      <Box mb={3}>
        <InfoBox
          title='TRANSACTION'
          total='52'
          lastMonth='0'
          lastWeek='0'
          today='0'
        />
      </Box>
      <Box component={Paper} minHeight={"600px"} elevation={0}>
        <Box px={3} py={2}>
          <Typography variant='h4'>Transactions</Typography>
        </Box>
        <Divider />
        <Box px={3} my={3}>
          <TransactionData />
        </Box>
        <Box width={"50%"} mx='auto' my={3} p={3}>
          <Pagination
            count={10}
            showFirstButton
            showLastButton
            shape='rounded'
          />
        </Box>
      </Box>
    </>
  );
};
export default Transaction;
